// optionFilter — case-insensitive substring filter over asset-picker options
// ({ name } records). Used by the wizard clip/audio dropdowns (PrefabWizard's
// type-to-filter). Pure — lives in lib (not the .jsx component) so node:test
// can drive it directly: tests/unit/wizardOptionFilter.test.mjs.
export function filterOptions(options, query) {
  const q = String(query ?? '').trim().toLowerCase()
  if (!q) return options
  return options.filter(o => String(o?.name ?? '').toLowerCase().includes(q))
}
